var BusinessRichCardEvents;

(function (BusinessRichCardEvents) {
  BusinessRichCardEvents["EDIT_PRODUCT_CURATION"] = "EDIT_PRODUCT_CURATION";
  BusinessRichCardEvents["EDIT_EXPERIENCE_CURATION"] = "EDIT_EXPERIENCE_CURATION";
  BusinessRichCardEvents["OPEN_RATED_ITEMS_PANEL"] = "OPEN_RATED_ITEMS_PANEL";
  BusinessRichCardEvents["OPEN_QUICK_CURATION_FLYOUT"] = "OPEN_QUICK_CURATION_FLYOUT";
})(BusinessRichCardEvents || (BusinessRichCardEvents = {}));

export { BusinessRichCardEvents };
//# sourceMappingURL=index.js.map
